module.exports = __webpack_public_path__ + "img/drug-8.2058e6a6.png";